import i18n from 'i18next';

import { ConditionOperatorType, ConditionVariableType, Dictionaries, InputType } from '@enums';
import { convertEnumToObjectArray, getOptionListFromCatalog } from '@utils';

export const getWAFConditionsColumns = (): any => [
  {
    label: i18n.t('configuration:tables.variable'),
    value: 'field',
    multiLines: true,
    inputType: InputType.Select,
    options: getOptionListFromCatalog({ name: Dictionaries.Variable }),
  },
  {
    label: i18n.t('configuration:tables.operator'),
    value: 'operator',
    multiLines: true,
    inputType: InputType.Select,
    options: getOptionListFromCatalog({ name: Dictionaries.Operator }),
  },
  {
    label: i18n.t('configuration:tables.value'),
    value: 'value',
    multiLines: true,
    inputType: InputType.Text,
    placeholder: 'Enter Your Value',
  },
  {
    label: i18n.t('configuration:tables.action'),
    value: 'action',
    multiLines: true,
    inputType: InputType.Action,
  },
];

export const getWAFRulesColumns = (): any => [
  {
    label: i18n.t('configuration:tables.variable'),
    value: 'field',
    multiLines: true,
    inputType: InputType.Select,
    options: [...convertEnumToObjectArray(ConditionVariableType)],
  },
  {
    label: i18n.t('configuration:tables.operator'),
    value: 'operator',
    multiLines: true,
    inputType: InputType.Select,
    options: [...convertEnumToObjectArray(ConditionOperatorType)],
  },
  {
    label: i18n.t('configuration:tables.value'),
    value: 'value',
    multiLines: true,
    inputType: InputType.Text,
    placeholder: 'Enter Your Value',
  },
  {
    label: i18n.t('configuration:tables.action'),
    value: 'action',
    multiLines: true,
    inputType: InputType.Action,
  },
];
